module.exports = __webpack_public_path__ + "3a62095bf4e74b13aa336083a7da0b86.png";